/**
 * App – shell for the DOCX marker print flow, with a Help page.
 */

import * as React from "react";
import { I18nProvider } from "@/i18n";
import PrintPage from "@/pages/PrintPage";
import HelpPage from "@/pages/HelpPage";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "sonner";

export default function App() {
  return (
    <ErrorBoundary>
      <I18nProvider>
        <AppShell />
        <Toaster
          position="top-right"
          richColors
          closeButton
          toastOptions={{
            classNames: {
              toast: "font-sans",
            },
          }}
        />
      </I18nProvider>
    </ErrorBoundary>
  );
}

function AppShell() {
  const [view, setView] = React.useState<"print" | "help">("print");

  // Keep the browser tab title in sync with the active view.
  React.useEffect(() => {
    document.title =
      view === "help"
        ? "Hướng dẫn sử dụng — In Ấn Chứng Từ | BizBox.Asia"
        : "In Ấn Chứng Từ — BizBox.Asia | Tạo & In Phiếu Từ Excel";
  }, [view]);

  if (view === "help") {
    return <HelpPage onBack={() => setView("print")} />;
  }
  return <PrintPage onOpenHelp={() => setView("help")} />;
}
